import React from 'react'
import * as yup from 'yup'
import InputInFormControl from './atoms/InputInFormControl'
import TextareaInFormControl from './atoms/TextareaInFormControl'
// import { CountrySelectInFormControl, StateSelectInFormControl, CitySelectInFormControl } from './atoms/CountryStateCity'
import { useWatch } from 'react-hook-form'

import CountrySelectInFormControl from './atoms/CountrySelectInFormControl'
import RegionSelectInFormControl from './atoms/RegionSelectInFormControl'
import SalutationSelectInFormControl from './atoms/SalutationSelectInFormControl'

import zipTwoObjectsBy from './utils/zipTwoObjectsBy'
import { zipcodeRegex, phoneRegex } from './utils/regexes'

const labels = {
  email: 'Email address',
  first_name: 'First name',
  last_name: 'Last name',
  salutation: 'Salutation',
  zipcode: 'Zipcode',
  country: 'Country',
  state: 'State',
  city: 'City',
  address_line: 'Street and Nr.',
  phone: 'Phone',
  note: 'Note',
}

export function makeYupSchemaFrom_required_address_fields (required_address_fields) {
  // NOTE: label should be after first string()
  const yupShape = zipTwoObjectsBy(
    required_address_fields,
    {
      first_name: yup.string().trim().label(labels.first_name),
      last_name: yup.string().trim().label(labels.last_name),
      salutation: yup.string().trim().label(labels.salutation),
      country: yup.string().trim().label(labels.country),
      state: yup.string().trim().label(labels.state),
      city: yup.string().trim().label(labels.city),
      address_line: yup.string().trim().label(labels.address_line),
      zipcode: yup.string().trim().matches(zipcodeRegex, { message: 'Zipcode is not valid', excludeEmptyString: true }).label(labels.zipcode),
      phone: yup.string().trim().matches(phoneRegex, { message: 'Phone number is not valid', excludeEmptyString: true }).label(labels.phone),
    },
    (isValue, yupSchemaValue) => {
      if (!yupSchemaValue) { throw new Error(`yupSchemaValue ${yupSchemaValue}`) }
      if (isValue === true) { return yupSchemaValue.required() }
      if (isValue === false) { return yupSchemaValue }
      throw new Error(`isValue ${isValue}`)
    },
  )

  const schema = yup.object().shape({
    ...yupShape,
    email: yup.string().email().required().label(labels.email),
    note: yup.string().trim().label(labels.note),
  })
  return schema
}

// const shape = {
//   email: { required: true, pattern: emailRegex },
//   first_name: { required: required_address_fields.first_name },
//   last_name: { required: required_address_fields.last_name },
//   salutation: { required: required_address_fields.salutation },
//   country: { required: required_address_fields.country },
//   state: { required: required_address_fields.state },
//   city: { required: required_address_fields.city },
//   address_line: { required: required_address_fields.address_line },
//   zipcode: { required: required_address_fields.zipcode, pattern: zipcodeRegex },
//   phone: { required: required_address_fields.phone, pattern: phoneRegex },
//   note: { required: false },
// }

// helper={modalFields_email_disabled ? 'Disabled since You are logged in' : null}
export const AddressFields = ({ control, register, modalFields_email_disabled, modalFields_note_show, required_address_fields }) => {
  // numbers
  const countryCode = useWatch({ name: 'country', control })
  // const countryCode_ = countryCode === undefined ? null : countryCode // if unlogged - fix: useControllableReducer: The useSelect component is changing an uncontrolled prop to be controlled: selectedValues
  // console.log('watchedFieldsCountryState', { countryCode })

  if (!(modalFields_note_show === true || modalFields_note_show === false)) { throw new Error('modalFields_note_show') }
  if (!(modalFields_email_disabled === true || modalFields_email_disabled === false)) { throw new Error('modalFields_email_disabled') }

  return (
    <>
      <InputInFormControl id='email' name='email' label={labels.email} required type='email' control={control} disabled={modalFields_email_disabled} />

      <InputInFormControl id='first_name' name='first_name' label={labels.first_name} required={required_address_fields.first_name} control={control} />
      <InputInFormControl id='last_name' name='last_name' label={labels.last_name} required={required_address_fields.last_name} control={control} />

      <InputInFormControl id='zipcode' name='zipcode' label={labels.zipcode} required={required_address_fields.zipcode} control={control} helper='Some banks require address information to filter out donations from stolen credit cards' />

      <SalutationSelectInFormControl id='salutation' name='salutation' label={labels.salutation} required={required_address_fields.salutation} control={control} />
      <CountrySelectInFormControl id='country' name='country' label={labels.country} control={control} required={required_address_fields.country} />
      <RegionSelectInFormControl id='state' name='state' label={labels.state} control={control} required={required_address_fields.state} countryCode={countryCode} />

      {/*
      <CountrySelectInFormControl label={labels.country} required={required_address_fields.country} control={control} {...register('country')} />
      <RegionSelectInFormControl label={labels.state} required={required_address_fields.state} control={control} {...register('state')} />
      */}

      <InputInFormControl id='city' name='city' label={labels.city} required={required_address_fields.city} control={control} />

      <InputInFormControl id='address_line' name='address_line' label={labels.address_line} required={required_address_fields.address_line} control={control} />
      <InputInFormControl id='phone' name='phone' label={labels.phone} required={required_address_fields.phone} type='tel' control={control} />

      {modalFields_note_show &&
        <TextareaInFormControl id='note' name='note' label={labels.note} required={false} control={control} placeholder='Extra delivery address? Want to tell us something? Type it here' />}
    </>
  )

  // defaultValue=''
  // on 'note'
  // doesnt prevent error if useForm({ defaultValues: { asdf: "asdf", note: undefined } })
}
